module.exports = __webpack_public_path__ + "img/logo.990c5cdf.png";